import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import ZonaCargando from '../alertas/zonaCargando';
import ResumenReserva from '../../componentesEspeciales/reserva/resumenReserva';
import EstadoReserva from '../../componentesEspeciales/reserva/estadoReserva';
import ChatReserva from '../../componentesEspeciales/reserva/chatReserva';
import { estrellas } from '../../funcionesDatos/Textos';

const BADGE_ESTADO = {
    hold:        { bg: "rgba(var(--amarillo-warning-rgb), 0.15)",  color: "var(--dorado-oscuro)" },
    confirmado:  { bg: "rgba(var(--azul-bootstrap-cta-rgb), 0.1)",  color: "var(--azul-bootstrap-cta)" },
    completado:  { bg: "rgba(var(--verde-bootstrap-rgb), 0.1)",   color: "var(--verde-bootstrap)" },
    cancelado:   { bg: "rgba(var(--rojo-error-rgb), 0.1)",   color: "var(--rojo-error)" },
    rechazado:   { bg: "rgba(var(--rojo-error-rgb), 0.1)",   color: "var(--rojo-error)" },
};

function tarjetaUsuario(u, rol) {
    const nombre = u ? ([u.nombre, u.apellido].filter(Boolean).join(" ") || "—") : null;
    return (
        <div className="col-12 col-md-6">
            <div className="card border-0 shadow-sm rounded-4 h-100">
                <div className="card-body py-3 px-4">
                    <p className="text-muted small mb-2 fw-semibold text-uppercase" style={{ letterSpacing: "0.05em" }}>
                        {rol}
                    </p>
                    {u ? (
                        <div className="d-flex align-items-center gap-3">
                            <img
                                src={u.avatar || "/imagenes/marca/avatar.png"}
                                alt={nombre}
                                className="rounded-circle flex-shrink-0"
                                style={{ width: 44, height: 44, objectFit: "cover" }}
                            />
                            <div className="min-w-0 flex-grow-1">
                                <p className="mb-0 fw-semibold text-dark">{nombre}</p>
                                <p className="mb-0 text-muted small">
                                    @{u.username || "—"} · {u.email || "—"}
                                </p>
                            </div>
                            {u.username && (
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary rounded-pill px-3 flex-shrink-0"
                                    onClick={() => {
                                        localStorage.setItem("admin_nav_usuario", JSON.stringify({ username: u.username }));
                                        window.open("/admin/usuario", "_blank");
                                    }}
                                >
                                    <i className="bi bi-person-badge me-1"></i>Ver
                                </button>
                            )}
                        </div>
                    ) : (
                        <p className="text-muted small mb-0">
                            <i className="bi bi-person-dash me-1"></i>Sin información registrada
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
}

const LABEL_ESTADO_RECLAMO = {
    NA:                              { label: "Sin reclamo",                         color: "var(--verde-bootstrap)" },
    abierto:                         { label: "Abierto",                              color: "var(--rojo-error)" },
    en_revision:                     { label: "En revisión",                          color: "var(--naranja-mapa)" },
    resuelto_a_favor_comprador:      { label: "Resuelto a favor del comprador",       color: "var(--azul-bootstrap-cta)" },
    resuelto_a_favor_proveedor:      { label: "Resuelto a favor del vendedor",        color: "var(--azul-bootstrap-cta)" },
    cerrado:                         { label: "Cerrado",                              color: "var(--gris-suave)" },
};

function SeccionReclamo({ reclamo }) {
    const tieneReclamo = reclamo?.abierto === true || (reclamo?.estado && reclamo.estado !== "NA");
    const estadoInfo   = LABEL_ESTADO_RECLAMO[reclamo?.estado] || LABEL_ESTADO_RECLAMO.NA;

    const fmt = (fecha) => fecha ? new Date(fecha).toLocaleString("es-CO", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

    return (
        <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body py-3 px-4">
                <div className="d-flex align-items-center gap-2 mb-3">
                    <i className={`bi ${tieneReclamo ? "bi-shield-exclamation text-danger" : "bi-shield-check text-success"} fs-5`}></i>
                    <h6 className="fw-semibold mb-0">Reclamo / Disputa</h6>
                    <span className="ms-auto badge rounded-pill px-3 py-1" style={{ background: `${estadoInfo.color}18`, color: estadoInfo.color, fontSize: "0.75rem" }}>
                        {estadoInfo.label}
                    </span>
                </div>

                {tieneReclamo ? (
                    <div className="row g-3">
                        {reclamo.motivo && reclamo.motivo !== "NA" && (
                            <div className="col-12 col-md-6">
                                <p className="text-muted small mb-1">Motivo</p>
                                <p className="mb-0 fw-semibold">{reclamo.motivo}</p>
                            </div>
                        )}
                        {reclamo.descripcion && reclamo.descripcion !== "NA" && (
                            <div className="col-12">
                                <p className="text-muted small mb-1">Descripción</p>
                                <p className="mb-0">{reclamo.descripcion}</p>
                            </div>
                        )}
                        {reclamo.resolucion && reclamo.resolucion !== "NA" && (
                            <div className="col-12">
                                <p className="text-muted small mb-1">Resolución</p>
                                <p className="mb-0">{reclamo.resolucion}</p>
                            </div>
                        )}
                        <div className="col-12 col-md-6">
                            <p className="text-muted small mb-1">Fecha de apertura</p>
                            <p className="mb-0">{fmt(reclamo.fechaApertura)}</p>
                        </div>
                        {reclamo.fechaCierre && (
                            <div className="col-12 col-md-6">
                                <p className="text-muted small mb-1">Fecha de cierre</p>
                                <p className="mb-0">{fmt(reclamo.fechaCierre)}</p>
                            </div>
                        )}
                    </div>
                ) : (
                    <p className="text-muted small mb-0">Esta reserva no tiene reclamos registrados.</p>
                )}
            </div>
        </div>
    );
}

// Reseña que dejó el comprador sobre esta reserva (modelo Valoracion, viene en valoracionesActuales de
// /obtener-reserva-admin-completa). Sirve para hacer seguimiento: si no hay reseña lo dice explícitamente,
// distinguiendo si todavía no podía dejarla (reserva sin completar) o si ya podía y no lo hizo.
function SeccionResena({ valoraciones, reserva, comprador }) {
    const lista = Array.isArray(valoraciones) ? valoraciones : [];
    const completada = reserva?.estado === "completado";

    const fmt = (fecha) => fecha ? new Date(fecha).toLocaleString("es-CO", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
    const colorCalificacion = (n) => n >= 4 ? "var(--verde-bootstrap)" : n === 3 ? "var(--naranja-mapa)" : "var(--rojo-error)";

    return (
        <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body py-3 px-4">
                <div className="d-flex align-items-center gap-2 mb-3">
                    <i className={`bi ${lista.length ? "bi-star-fill" : "bi-star"} fs-5`} style={{ color: lista.length ? "var(--ambar-600)" : "var(--gris-suave)" }}></i>
                    <h6 className="fw-semibold mb-0">Reseña del comprador</h6>
                    <span className="ms-auto badge rounded-pill px-3 py-1" style={{
                        background: lista.length ? "rgba(var(--verde-bootstrap-rgb), 0.1)" : "rgba(var(--rojo-error-rgb), 0.08)",
                        color: lista.length ? "var(--verde-bootstrap)" : "var(--rojo-error)",
                        fontSize: "0.75rem",
                    }}>
                        {lista.length ? "Con reseña" : "Sin reseña"}
                    </span>
                </div>

                {lista.length ? (
                    <div className="d-flex flex-column gap-3">
                        {lista.map((v) => {
                            const n = Number(v.calificacion) || 0;
                            return (
                                <div key={v.idValoracion || v._id} className="border rounded-4 p-3" style={{ background: "var(--color-bg-surface-alt)" }}>
                                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
                                        <div className="d-flex align-items-center gap-2">
                                            <span style={{ color: "var(--ambar-600)", letterSpacing: 1, fontSize: "1.1rem" }}>{estrellas(n)}</span>
                                            <span className="fw-bold" style={{ color: colorCalificacion(n) }}>{n}/5</span>
                                        </div>
                                        <small className="text-muted">{fmt(v.fecha || v.createdAt)}</small>
                                    </div>
                                    <p className="mb-2" style={{ whiteSpace: "pre-wrap", lineHeight: 1.55 }}>
                                        {v.comentario ? v.comentario : <span className="text-muted fst-italic">Dejó la calificación sin comentario.</span>}
                                    </p>
                                    <small className="text-muted">
                                        Por {v.nombreUsuario || [comprador?.nombre, comprador?.apellido].filter((x) => x && x !== "NA").join(" ") || comprador?.username || "el comprador"}
                                        {v.idValoracion ? <> · <span style={{ fontFamily: "monospace" }}>{v.idValoracion}</span></> : null}
                                    </small>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <p className="text-muted small mb-0">
                        <i className="bi bi-chat-square me-1"></i>
                        {completada
                            ? "No dejó reseña. La reserva ya está completada, así que el comprador ya podía calificarla."
                            : "No dejó reseña. El comprador podrá calificarla cuando la reserva esté completada."}
                    </p>
                )}
            </div>
        </div>
    );
}

function ReservaAdminIndividual() {
    const { usuario, cargandoUsuario, ahoraServidor } = useOutletContext() || {};
    const navigate = useNavigate();
    const location = useLocation();
    const { idReserva } = location.state?.params || {};

    const [cargando, setCargando] = useState(false);
    const [reserva, setReserva] = useState(null);
    const [servicio, setServicio] = useState(null);
    const [mensajes, setMensajes] = useState(null);
    const [valoraciones, setValoraciones] = useState(null);
    const [comprador, setComprador] = useState(null);
    const [proveedor, setProveedor] = useState(null);

    useEffect(() => {
        if (!idReserva) {
            Swal.fire({ icon: "error", title: "Reserva no disponible", text: "No fue posible identificar la reserva.", confirmButtonColor: "var(--azul-logo-fondo)" });
            navigate(-1);
            return;
        }

        (async () => {
            try {
                setCargando(true);
                const res = await axios.post("/obtener-reserva-admin-completa", { params: { idReserva } });
                if (!res.data.exito) {
                    Swal.fire({ icon: "error", title: "Error", text: res.data.mensaje || "No se pudo cargar la reserva.", confirmButtonColor: "var(--azul-logo-fondo)" });
                    return navigate(-1);
                }
                setReserva(res.data.reservaActual);
                setServicio(res.data.servicioActual);
                setMensajes(res.data.mensajesActuales);
                setValoraciones(res.data.valoracionesActuales);
                setComprador(res.data.comprador);
                setProveedor(res.data.proveedor);
            } catch (err) {
                console.log("Error cargando reserva admin:", err);
                Swal.fire({ icon: "error", title: "Error", text: "No se pudo cargar la reserva.", confirmButtonColor: "var(--azul-logo-fondo)" });
                navigate(-1);
            } finally {
                setCargando(false);
            }
        })();
    }, [idReserva, navigate]);

    if (cargando || cargandoUsuario) return <ZonaCargando />;

    const estadoEstilo = reserva ? (BADGE_ESTADO[reserva.estado] || {}) : {};

    return (
        <div className="container-fluid">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-start pt-3 pb-2 mb-4 border-bottom">
                <div>
                    <div className="d-flex align-items-center gap-3 flex-wrap">
                        <h1 className="h2 text-dark mb-0">Reserva</h1>
                        {reserva?.estado && (
                            <span
                                className="badge rounded-pill px-3 py-1"
                                style={{ background: estadoEstilo.bg, color: estadoEstilo.color, fontSize: "0.8rem" }}
                            >
                                {reserva.estado.charAt(0).toUpperCase() + reserva.estado.slice(1)}
                            </span>
                        )}
                    </div>
                    {idReserva && (
                        <p className="text-muted small mb-0 mt-1" style={{ fontFamily: "monospace", fontSize: "0.72rem" }}>
                            ID: {idReserva}
                        </p>
                    )}
                </div>
                <button
                    className="btn btn-outline-secondary btn-sm rounded-3 flex-shrink-0"
                    onClick={() => navigate(-1)}
                >
                    <i className="bi bi-arrow-left me-1"></i>Volver
                </button>
            </div>

            {/* Partes de la reserva */}
            <div className="row g-3 mb-4">
                {tarjetaUsuario(comprador, "Comprador")}
                {tarjetaUsuario(proveedor, "Vendedor")}
            </div>

            {/* Contenido principal */}
            {reserva && servicio ? (
                <>
                    <div className="row g-4 align-items-stretch">
                        <div className="col-12 col-lg-6">
                            <ResumenReserva reserva={reserva} servicio={servicio} />
                        </div>
                        <div className="col-12 col-lg-6">
                            <EstadoReserva
                                reserva={reserva}
                                quienEs="Comprador"
                                usuario={comprador || usuario}
                                servicio={servicio}
                                ahoraServidor={ahoraServidor}
                                valoraciones={valoraciones}
                                soloLectura={true}
                            />
                            <ChatReserva
                                reserva={reserva}
                                usuario={comprador || usuario}
                                mensajesTodos={mensajes}
                                quienEs="Comprador"
                                soloLectura={true}
                                telefonosAdmin={[
                                    { rol: "Comprador", usuario: comprador },
                                    { rol: "Vendedor",  usuario: proveedor },
                                ]}
                            />
                        </div>
                    </div>

                    {/* Reseña del comprador */}
                    <div className="row g-4 mt-2">
                        <div className="col-12">
                            <SeccionResena valoraciones={valoraciones} reserva={reserva} comprador={comprador} />
                        </div>
                    </div>

                    {/* Reclamo */}
                    <div className="row g-4 mt-2">
                        <div className="col-12">
                            <SeccionReclamo reclamo={reserva.reclamo} />
                        </div>
                    </div>
                </>
            ) : (
                !cargando && (
                    <div className="text-center py-5 text-muted">
                        <i className="bi bi-calendar-x fs-2 d-block mb-2"></i>
                        No se encontraron datos de la reserva.
                    </div>
                )
            )}
        </div>
    );
}

export default ReservaAdminIndividual;
